import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '2021重庆两会连连看';
const baseUrl = '2021-cqlh-lian-lian-kan';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/welcome`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'welcome',
      name: `${baseUrl}-welcome`,
      component: () => import('./pages/Welcome.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'district-toutiao',
      name: `${baseUrl}-toutiao`,
      component: () => import('./pages/TouTiao.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'district-detail',
      name: `${baseUrl}-detail`,
      component: () => import('./pages/Detail.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
